import React, { Component } from "react";
import AddVehicle from "../../components/AddNewVehicle/AddVehicle";
import Dashboard from "../../layouts/DashboardLayOut";
import { Typography } from "@mui/material";

export class AddNewVehicle extends Component {
  render() {
    return (
      <Dashboard>
        <Typography variant="h5" component="h5" style={{color:'#083979'}}>Vehicle information</Typography>
        <AddVehicle />
      </Dashboard>
    );
  }
}

export default AddNewVehicle;
